module.exports = __webpack_public_path__ + "img/40_69_011_940.52d22780.jpg";